import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  setActiveItem,
  selectActiveItemId,
} from '../../../../../common/components/ToolbarItem/slice'

export const PERSONAL_SPACE_ID = 'personal_space'

export const useActiveItem = () => {
  const dispatch = useDispatch()

  const currentActiveItem = useSelector(selectActiveItemId)

  const changeActiveItemToPersonalSpace = useCallback(() => {
    dispatch(setActiveItem(PERSONAL_SPACE_ID))
  }, [dispatch])

  useEffect(() => {
    !currentActiveItem && void changeActiveItemToPersonalSpace()
  }, [currentActiveItem, changeActiveItemToPersonalSpace])

  return { changeActiveItemToPersonalSpace }
}
